export const pinTitle = "JPb";
export default {pinTitle};